import React, { useEffect, useState } from 'react';
import RegistrationFormPanel from '../../components/RegistrationFormPanel';

// Live preview frame for the registration builder. The builder (same origin) posts
// the form being edited; this page shows exactly what families will see, at the
// frame's real width (phone or desktop). Nothing is saved or sent from here.
export default function RegPreviewPage() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const onMsg = (e) => {
      if (e.origin !== window.location.origin || e.data?.type !== 'ol-reg-preview') return;
      setData({ form: e.data.form, brand: e.data.brand });
    };
    window.addEventListener('message', onMsg);
    window.parent?.postMessage({ type: 'ol-reg-preview-ready' }, window.location.origin);
    return () => window.removeEventListener('message', onMsg);
  }, []);
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 py-3 px-3" data-testid="reg-preview-page">
      {data ? <RegistrationFormPanel preview={data} /> : <p className="text-center text-sm text-slate-500 py-10">Loading preview…</p>}
    </div>
  );
}
